import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

export const MyPreset = definePreset(Aura, {
  components: {
    toast: {
      root: {
        width: 'auto',
      },
    },
    card: {
      root: {
        borderRadius: '6px',
      },
    },
    button: {
      root: {
        paddingX: '10.5px',
        paddingY: '7px',
        gap: '7px',
      },
      colorScheme: {
        light: {
          root: {
            secondary: {
              background: '#fff',
              hoverBackground: '{slate.100}',
              activeBackground: '{slate.200}',
              color: '{slate.500}',
              borderColor: '{slate.200}',
            },
          },
        },
      },
    },
    tabs: {
      tablist: {
        background: '',
        borderColor: '#CED6DA',
      },
      tab: {
        color: '#8599A3',
        activeBackground: '',
        activeColor: '#1C4254',
        activeBorderColor: '#1C4254',
        borderColor: '#CED6DA',
      },
      activeBar: {
        background: '#1C4254',
      },
    },
    timeline: {
      event: {},
    },
    inplace: {
      root: {
        padding: '0px',
      },
    },
  },
  semantic: {
    primary: {
      50: '#f7fee7',
      100: '#ecfccb',
      200: '#d9f99d',
      300: '#bef264',
      400: '#a3e635',
      500: '#84cc16',
      600: '#65a30d',
      700: '#4d7c0f',
      800: '#3f6212',
      900: '#365314',
      950: '#1a2e05',
    },
    colorScheme: {
      light: {
        surface: {
          0: '#ffffff',
          50: '{slate.50}',
          100: '{slate.100}',
          200: '{slate.200}',
          300: '{slate.300}',
          400: '{slate.400}',
          500: '{slate.500}',
          600: '{slate.600}',
          700: '{slate.700}',
          800: '{slate.800}',
          900: '{slate.900}',
          950: '{slate.950}',
        },
      },
    },
  },
});
